import {
  FaHome,
  FaUserMd,
  FaUserInjured,
  FaCalendarCheck,
  FaEnvelope,
  FaTools,
  FaEnvelopeOpen,
  FaPhoneAlt,
  FaUserCircle,
  FaPuzzlePiece,
  FaFileAlt,
  FaNewspaper,
  FaAmbulance,
  FaBirthdayCake,
  FaPills,
  FaMicroscope,
  FaUserAlt,
  FaRetweet,
  FaHospital,
  FaStore,
  FaNotesMedical,
  FaProcedures,
  FaChartBar,
} from "react-icons/fa";
import { HiOutlineBookOpen } from "react-icons/hi";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { RiHealthBookFill } from "react-icons/ri";

export const sidebarSections = [
  {
    title: "Main Menu",
    sectionKey: "main",
    menus: [
      {
        name: "Dashboard",
        icon: FaHome,
        link: "/",
        isSubmenu: false,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
      },
      {
        name: "Manage Doctors",
        icon: FaUserMd,
        link: "/manage-doctors",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "All Doctors",
            link: "/all-doctors",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: true,
          },
          {
            name: "Add New Doctor",
            link: "/add-doctor",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: true,
          },
          {
            name: "Add Department",
            link: "/add-department",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: true,
          },
          {
            name: "All Department",
            link: "/all-department",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: true,
          },
        ],
      },
      {
        name: "Manage Patients",
        icon: FaUserInjured,
        link: "/manage-patients",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "All Patients",
            link: "/all-patients",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Add New Patient",
            link: "/add-patient",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "My Practice",
        icon: FaNotesMedical,
        link: "#",
        isSubmenu: true,
        isDoctor: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        submenus: [
          { name: "All Patients", link: "/my-patients", isDoctor: true },
          {
            name: "All Appointments",
            link: "/my-appointments",
            isDoctor: true,
          },
          {
            name: "Book Appointment",
            link: "/book-appointment",
            isDoctor: true,
          },
          {
            name: "My Payments",
            link: "/my-payments",
            isDoctor: true,
          },
        ],
      },
      {
        name: "Manage Appointment",
        icon: FaCalendarCheck,
        link: "#",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        isPatient: true,
        submenus: [
          {
            name: "All Appointments",
            link: "/all-appointments",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "My Appointments",
            link: "/my-appointment",
            isPatient: true,
            isAdmin: false,
            isDoctor: false,
            isPathologist: false,
          },
          {
            name: "Upcoming Appointments",
            link: "/upcoming-appointments",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Today's Appointments",
            link: "/todays-appointments",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Add New Appointment",
            link: "/add-appointment",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
    ],
  },
  {
    title: "Pharmacy",
    sectionKey: "pharmacy",
    menus: [
      {
        name: "Pharmacy",
        icon: FaPills,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: true,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Pharmacy Bill",
            link: "/pharmacy-bill",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Medicines",
            link: "/medicines",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Import Medicines",
            link: "/import-medicines",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Purchase Medicine",
            link: "/purchase-medicine",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Pharmacy Config",
            link: "/pharmacy-list",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
        ],
      },
      {
        name: "Return",
        icon: FaRetweet,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: true,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Add Return",
            link: "/add-return",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Invoice Return List",
            link: "/invoice-return-list",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Supplier Return List",
            link: "/supplier-return-list",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Wastage Return List",
            link: "/wastage-return-list",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: true,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
    ],
  },
  {
    title: "Pathology",
    sectionKey: "pathology",
    menus: [
      {
        name: "Pathology",
        icon: FaMicroscope,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: true,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: true,
        isDoctor: false,
        submenus: [
          // { name: "Lab Test", link: "/pathology-lab-test", isAdmin: false, isSuperAdmin: false, isPathologist: true, isPharmacist: false, isNicuInCharge: false, isHospitalManager: false, isDoctor: false },
          {
            name: "All Reports",
            link: "/pathology-reports",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: true,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Pathology Bill",
            link: "/pathology-bill",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: true,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
            isDoctor: false,
          },
          {
            name: "Pathology Config",
            link: "/pathology-config",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: true,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Pathology Accounts",
        icon: FaChartBar,
        link: "#",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: true,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: true,
        isDoctor: false,
        submenus: [
          {
            name: "Refer Ledger",
            link: "/pathology/refer-ledger",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "Doctor Ledger",
            link: "/pathology/doctor-ledger",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "User-wise Collection",
            link: "/pathology/user-collection",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "Account Summary",
            link: "/pathology/account-summary",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "Expert Posting",
            link: "/pathology/expert-posting",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "Others Expense",
            link: "/pathology/others-expense",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "Daily Closing",
            link: "/pathology/daily-closing",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "Monthly Reports",
            link: "/pathology/monthly-reports",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
          {
            name: "MD Sir Account",
            link: "/pathology/md-account",
            isAdmin: true,
            isSuperAdmin: true,
            isHospitalManager: true,
            isPathologist: true,
          },
        ],
      },
      {
        name: "My Reports",
        icon: FaFileAlt,
        link: "/my-reports",
        isSubmenu: false,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        isPatient: true,
      },
    ],
  },
  {
    title: "NICU",
    sectionKey: "nicu",
    menus: [
      {
        name: "NICU",
        icon: RiHealthBookFill,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: true,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Admission",
            link: "/nicu-patients",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: true,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "NICU Bill",
            link: "/nicu-bill",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: true,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "NICU Config",
            link: "/nicu-config",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: true,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Advance Payment",
            link: "/nicu-advance-payment",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "Office Expense Items",
            link: "/nicu-office-expense-items",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: true,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Office Expense",
            link: "/nicu-office-expense",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "Discount Users",
            link: "/nicu-discount-users",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "Refer Ledger",
            link: "/nicu-refer-ledger",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "Discount Report",
            link: "/nicu-discount-report",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "X-ray List",
            link: "/nicu-xray-type",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "X-ray",
            link: "/nicu-xray",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
          {
            name: "Account Summary",
            link: "/nicu-account-summary",
            isAdmin: false, isSuperAdmin: false, isPathologist: false,
            isPharmacist: false, isNicuInCharge: true,
            isHospitalManager: false, isDoctor: false,
          },
        ],
      },
    ],
  },
  {
    title: "Emergency",
    sectionKey: "emergency",
    menus: [
      {
        name: "Emergency",
        icon: RiHealthBookFill,
        link: "#",
        isSubmenu: true,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        submenus: [
          {
            name: "Emergency Bill",
            link: "/emergency-bill",
            isNicuInCharge: true,
          },
          {
            name: "Emergency Config",
            link: "/emergency-config",
            isNicuInCharge: true,
          },
        ],
      },
    ],
  },
  {
    title: "Hospital Office",
    sectionKey: "hospitalOffice",
    menus: [
      {
        name: "Hospital Office",
        icon: FaHospital,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: true,
        isDoctor: false,
        submenus: [
          {
            name: "Admission",
            link: "/hospital-patients",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Hospital Bill",
            link: "/hospital-bill",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Hospital Office Config",
            link: "/hospital-config",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
        ],
      },
      {
        name: "Outdoor OT",
        icon: FaProcedures,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: true,
        isDoctor: false,
        submenus: [
          {
            name: "Outdoor Bill",
            link: "/outdoor-bill",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
        ],
      },
      {
        name: "Office Accounts",
        icon: FaMoneyCheckDollar,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: true,
        isDoctor: false,
        submenus: [
          {
            name: "Office Deposits",
            link: "/office-deposits",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Office Expenses",
            link: "/office-expenses",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Account Summary",
            link: "/office-account-summary",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Office Config",
            link: "/office-config",
            isSubmenu: true,
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
        ],
      },
    ],
  },
  {
    title: "Store Management",
    sectionKey: "storeManagement",
    menus: [
      {
        name: "Store Management",
        icon: FaStore,
        link: "#",
        isSubmenu: true,
        isAdmin: false,
        isSuperAdmin: false,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        submenus: [
          {
            name: "Total Assets",
            link: "/total-assets",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Wastage",
            link: "/wastage",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Store Asset",
            link: "/store-asset",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
        ],
      },
    ],
  },
  {
    title: "Accounts",
    sectionKey: "accounts",
    menus: [
      {
        name: "Accounts",
        icon: FaMoneyCheckDollar,
        link: "#",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: true,
        isDoctor: false,
        submenus: [
          {
            name: "Patient Ledger",
            link: "accounts/patient-ledger",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Doctor Ledger",
            link: "accounts/doctor-ledger",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: true,
          },
          {
            name: "Appointment",
            link: "accounts/appointment",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Pathology",
            link: "accounts/pathology",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Pharmacy",
            link: "accounts/pharmacy",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "NICU",
            link: "accounts/nicu",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Hospital Office",
            link: "accounts/hospital",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Emergency",
            link: "/accounts/emergency",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Ambulance",
            link: "accounts/ambulance",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
          {
            name: "Store",
            link: "/accounts/store",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Total Revenue",
            link: "accounts/revenue",
            isAdmin: false,
            isSuperAdmin: false,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
          },
        ],
      },
    ],
  },
  {
    title: "CMS & Blogs",
    sectionKey: "cms",
    menus: [
      {
        name: "Manage Users",
        icon: FaUserAlt,
        link: "/manage-users",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "User Management",
            link: "/user-management",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Manage Blogs",
        icon: FaNewspaper,
        link: "/manage-blogs",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "All Blogs",
            link: "/all-blog",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Add New Blog",
            link: "/add-blog",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Add New Category",
            link: "/add-category",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "All Category",
            link: "/all-category",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Manage Ambulance",
        icon: FaAmbulance,
        link: "/manage-page",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Ambulance Manage",
            link: "/ambulance-call",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Manage Birth & Death",
        icon: FaBirthdayCake,
        link: "",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Birth Manage",
            link: "/birth",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Death Manage",
            link: "/death",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Manage Pages",
        icon: FaFileAlt,
        link: "/manage-page",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "All Pages",
            link: "/all-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Add New Page",
            link: "/add-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Manage Sections",
        icon: FaPuzzlePiece,
        link: "/manage-sections",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Homepage Section",
            link: "/home-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "About us",
            link: "/about-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Diagnostic Page",
            link: "/diagnostic-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Contact Page",
            link: "/contact-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Header",
            link: "/header",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Footer",
            link: "/footer",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Add Review",
            link: "/add-reviews",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Website Setup",
        icon: HiOutlineBookOpen,
        link: "/website-setup",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Error Page Message",
            link: "/error-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
          {
            name: "Authority Page ",
            link: "/authority-page",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
    ],
  },
  {
    title: "Settings & Config",
    sectionKey: "settings",
    menus: [
      {
        name: "Settings",
        icon: FaTools,
        link: "/settings",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "All Notification",
            link: "/notifications",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
      {
        name: "Email Configuration",
        icon: FaEnvelope,
        link: "/email",
        isSubmenu: true,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
        submenus: [
          {
            name: "Email Config",
            link: "/email-config",
            isAdmin: true,
            isSuperAdmin: true,
            isPathologist: false,
            isPharmacist: false,
            isNicuInCharge: false,
            isHospitalManager: false,
            isDoctor: false,
          },
        ],
      },
    ],
  },
  {
    title: "Contact Menu",
    sectionKey: "contact",
    menus: [
      {
        name: "Contact",
        icon: FaEnvelopeOpen,
        link: "/contact",
        isSubmenu: false,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
      },
      {
        name: "Callback",
        icon: FaPhoneAlt,
        link: "/callback",
        isSubmenu: false,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
      },
    ],
  },
  {
    title: "Others",
    sectionKey: "others",
    menus: [
      {
        name: "Profile",
        icon: FaUserCircle,
        link: "/profile",
        isSubmenu: false,
        isAdmin: true,
        isSuperAdmin: true,
        isPathologist: false,
        isPharmacist: false,
        isNicuInCharge: false,
        isHospitalManager: false,
        isDoctor: false,
      },
    ],
  },
];